"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var js_util_1 = require("@giphy/js-util");
var api_1 = require("./api");
exports.GiphyFetch = api_1.default;
var paginator_1 = require("./paginator");
exports.gifPaginator = paginator_1.gifPaginator;
var version = require('../package.json').version;
// since we have multiple SDKs, we're defining a hieracrchy
// Fetch API is lowest
if (!((_a = js_util_1.getGiphySDKRequestHeaders()) === null || _a === void 0 ? void 0 : _a.get("X-GIPHY-SDK-NAME"))) {
    // send headers with library type and version
    js_util_1.appendGiphySDKRequestHeader("X-GIPHY-SDK-NAME", 'FetchAPI');
    js_util_1.appendGiphySDKRequestHeader("X-GIPHY-SDK-VERSION", version);
}
//# sourceMappingURL=index.js.map